import React from 'react';
import { Card, Row, Col, Form, Switch } from 'antd';
import { CompanySettings } from '../../../../types/company.types';

interface SmsSettingsFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  settings: CompanySettings;
  loading: boolean;
}

const SmsSettingsForm: React.FC<SmsSettingsFormProps> = ({ form, settings, loading }) => (
  <Card className="setting-card" title="SMS Ayarları">
    <Row gutter={[24, 16]}>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="İzin İsteği SMS"
          name="sendSmsLeave"
          valuePropName="checked"
          initialValue={settings.sendSmsLeave}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Talep SMS"
          name="sendSmsTicket"
          valuePropName="checked"
          initialValue={settings.sendSmsTicket}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Mazeret SMS"
          name="sendSmsExcuse"
          valuePropName="checked"
          initialValue={settings.sendSmsExcuse}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Mola SMS"
          name="sendSmsBreak"
          valuePropName="checked"
          initialValue={settings.sendSmsBreak}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
    </Row>
  </Card>
);

export default SmsSettingsForm;
